<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="810px" scrollable>
    <v-card :class="{'loading': loading}">
      <v-card-title class="headline grey lighten-2">
        <span class="headline">{{ page.title }}</span>
        <v-spacer />
        <tk-btn icon @click="$emit('input', !value)">
          <v-icon>fas fa-times</v-icon>
        </tk-btn>
      </v-card-title>
      <v-card-text style="min-height: 100px;">
        <tk-froala :content="page.content" />
        <!-- <div v-html="page.content"></div> -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ErrorHandler } from "@/utils/ErrorHandler";
import TkFroala from "@/components/core/TkFroala";

const handler = new ErrorHandler();
export default {
  props: ["value"],

  components: { TkFroala },

  data() {
    return {
      loading: false,
      page: {}
    };
  },

  watch: {
    value: {
      handler: function(val) {
        console.log("Watch page dialog value", val);
        if (val) {
          this.fetchData();
        }
      }
    }
  },

  methods: {
    async fetchData() {
      this.page = {};

      this.loading = true;
      await handler.handle(async () => {
        const res = await this.$axios.get(`pages/${this.$app.pageDialog.slug}`);
        this.page = res.data["data"];
      });
      this.loading = false;
    }
  }
};
</script>

